import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { usePopup } from '../../contexts/PopupContext';
import useWindowSize from '../../hooks/useWindowSize';

import Button from '../buttons/Button';
import EmailForm from '../partials/EmailForm';
import ClosePopup from '../icons/ClosePopup';

import lapin from '../../../img/lapin.png';

import styles from '../../../styles/modals/wabush.scss';

const propTypes = {
    // theme: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const WabushPopup = ({ color, onClose, className }) => {
    const { setPopup } = usePopup();
    const { width } = useWindowSize();

    const [showText, setShowText] = useState(true);

    const onSuccessClose = useCallback(
        (name) => {
            onClose(name);
            if (window.scrollTo) {
                if (width > 1320) {
                    window.scrollTo({ top: 800, behavior: 'smooth' });
                } else if (width > 767) {
                    window.scrollTo({ top: 680, behavior: 'smooth' });
                } else {
                    window.scrollTo({ top: 480, behavior: 'smooth' });
                }
            }
        },
        [width, setShowText],
    );

    const onSkip = useCallback(() => {
        setPopup(null);
    }, [setPopup]);

    const onSuccess = useCallback(() => {
        setShowText(false);
    }, [setShowText]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            style={{ backgroundColor: color }}
        >
            <div className={styles.content}>
                <h3 className={styles.title}>
                    La webdiffusion de <strong>L’enclos de Wabush</strong> est disponible
                    gratuitement jusqu’au 4 juillet 2021.
                </h3>
                {showText ? (
                    <p className={styles.text}>
                        Pour visionner la pièce, veuillez svp entrer une adresse courriel valide :
                    </p>
                ) : null}
                <EmailForm
                    className={styles.email}
                    path="wabush"
                    onClose={onSuccessClose}
                    onSuccess={onSuccess}
                />
            </div>
            <img className={styles.lapin} src={lapin} alt="Lapin" />
            <Button className={styles.close} onClick={onSkip}>
                <ClosePopup />
            </Button>
        </div>
    );
};

WabushPopup.propTypes = propTypes;
WabushPopup.defaultProps = defaultProps;

export default WabushPopup;
